/* eslint-disable react/jsx-props-no-spreading */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import AutocompleteFilter from './AutocompleteFilter';

export default class RegionFilter extends Component {
  static propTypes = {
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    options: PropTypes.array,
    selected: PropTypes.array,
    onChange: PropTypes.func,
  }

  static defaultProps = {
    options: [],
    selected: [],
    onChange() {},
  }

  renderItem(item) {
    const countrySeparatorIndex = item.name_with_path.indexOf('|');
    let beforeCountry = item.name_with_path;
    let country = '';

    if (countrySeparatorIndex !== -1) {
      beforeCountry = item.name_with_path.slice(0, countrySeparatorIndex);
      country = item.name_with_path.slice(countrySeparatorIndex + 1);
    }

    if (country.length !== 0) {
      country = (
        <span className="u-text-old-dark-grey u-ml-2">
          {country}
        </span>
      );
    }

    return (
      <>
        {beforeCountry}
        {country}
      </>
    );
  }

  render() {
    return (
      <AutocompleteFilter
        {...this.props}
        renderItem={this.renderItem}
      />
    );
  }
}
